export default __webpack_public_path__ + "static/media/338.0281e220.jpg";